import { TObject } from "corexxx";
import Chart from "react-apexcharts";
import { DRow } from "./DRow";
import React from "react";
import { Treemap, Tooltip, ResponsiveContainer } from "recharts";
const colorPalette = [
  "#FF6384",
  "#36A2EB",
  "#FFCE56",
  "#4BC0C0",
  "#9966FF",
  "#FFC107",
];

function generateColors(num: number) {
  const colors = [];
  for (let i = 0; i < num; i++) {
    colors.push(colorPalette[i % colorPalette.length]);
  }
  return colors;
}

export function PieChart() {
  let options: ApexCharts.ApexOptions = {
    grid: {
      show: false,
    },

    chart: {
      id: "basic-bar",
      zoom: {
        enabled: false,
      },
      height: 100,
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  };
  let series = [
    {
      name: "series-1",
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ];

  return <Chart type="area" series={series} options={options} />;
}
export const ColorBar = ({ config }: { config: TObject }) => {
  let total = Object.values(config).reduce((acc, curr) => acc + curr, 0);
  return (
    <DRow style={{ flex: 0 }}>
      {Object.keys(config).map((x) => (
        <div
          style={{
            height: 5,
            width: `${(config[x] / total) * 100}%`,
            background: x,
          }}
          key={x}
        />
      ))}
    </DRow>
  );
};

export const DTreeMap = ({
  data,
}: {
  data: { title: string; value: number }[];
}) => {
  // Prepare the data for the tree map
  const processedData = data.map((item) => ({
    name: item.title,
    size: item.value,
    fill: item.value > 0 ? "green" : "red",
    strokeWidth: 1,
    textColor: "red",
  }));

  return (
    <div style={{ width: "100%", height: 400 }}>
      <ResponsiveContainer>
        <Treemap
          width={730}
          height={250}
          isAnimationActive={false}
          data={processedData}
          dataKey="size"
          fill="white" // textcolor
          style={{ color: "red" }}
        >
          <Tooltip />
        </Treemap>
      </ResponsiveContainer>
    </div>
  );
};

// Custom tooltip to display additional data
const CustomContent = ({ payload }: { payload: any }) => {
  if (!payload || payload.length === 0) return null;

  const { name, size } = payload[0];
  return (
    <div
      style={{
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
      }}
    >
      <p>
        <strong>{name}</strong>
      </p>
      <p>Value: {size}</p>
    </div>
  );
};

// Example usage
const stockData = [
  { title: "Stock 1", value: 100 },
  { title: "Stock 2", value: 120 },
  { title: "Stock 3", value: 90 },
  { title: "Stock 4", value: 150 },
  { title: "Stock 5", value: 80 },
];
